import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import qs from "query-string";


function ScrollToTop({ history }) {
    useEffect(() => {
        const unlisten = history.listen(() => {
            const parsed = qs.parse(decodeURI(history.location.search));
            const arr = Object.entries(parsed);
            const id = parsed.id;
            if (id !== null && id !== undefined  && arr.length === 1) {
                window.scrollTo(0, 0);
            }
        });
        return () => {
            unlisten();
        }
    }, [history]);

    return (null);
}

export default withRouter(ScrollToTop);